module.exports = "/images/mic.svg?e3cdebe602c492eb59a620990021a13f";